import { Grid, GridSize } from '@material-ui/core';
import React from 'react';

import { publicaColors } from '~/src/dash/utils/colors';
import {
  IIASDashboardMetricsCard,
  IIASDashboardSelectableCardMetricInfo,
} from '~/src/dash/views/ias-publisher/IASDashboard/common/types';
import { IASDashboardSelectableCard } from '~/src/dash/views/ias-publisher/IASDashboard/IASDashboardSelectableCards/IASDashboardSelectableCard';

const getCardGridSize = (numCards: number) => {
  switch (numCards) {
    case 2:
      return 6 as GridSize;
    case 3:
      return 4 as GridSize;
    case 4:
      return 3 as GridSize;
    case 6:
      return 2 as GridSize;
    default:
      return true;
  }
};

interface IIASDashboardSelectableCardsProps {
  cards: IIASDashboardMetricsCard[];
  isComparedToEnabled: boolean;
  handleClickSelectableCard: (dataKey: string, index: number) => void;
  handleSwitchCardSelected: (newkey: string, index: number) => void;
  loadStatus: number;
  activeMetrics: Record<string, boolean>;
  colors: Record<string, string>;
  allMetrics: IIASDashboardSelectableCardMetricInfo[];
}

export const IASDashboardSelectableCards = ({
  cards,
  isComparedToEnabled,
  handleClickSelectableCard,
  handleSwitchCardSelected,
  loadStatus,
  colors,
  allMetrics,
}: IIASDashboardSelectableCardsProps) => {
  const numCards = cards.length;
  const cardColors = Object.values(colors);

  return (
    <Grid container spacing={2}>
      {cards.map((card, cardIndex) => {
        return (
          <Grid item xs={getCardGridSize(numCards)}>
            <IASDashboardSelectableCard
              color={cardColors[cardIndex] || publicaColors.gray}
              isComparedToEnabled={isComparedToEnabled}
              isInverseMetric={card.isInverseMetric}
              isPercentChangeNegative={card.isPercentChangeNegative}
              label={card.label}
              percentChange={card.percentChange}
              value={card.value}
              isActive={card.isActive || false}
              handleClickSelectableCard={handleClickSelectableCard}
              handleSwitchCardSelected={handleSwitchCardSelected}
              loadStatus={loadStatus}
              dataKey={card.dataKey}
              cards={cards}
              cardIndex={cardIndex}
              allMetrics={allMetrics}
            />
          </Grid>
        );
      })}
    </Grid>
  );
};
